import { Stack, useTheme } from "@mui/material";
import { Wallet } from "lucide-react";
import type { FC } from "react";
import { FinancialBalanceRowLabel } from "web_myplann/Dashboard/Components/FinancialBalanceRowLabel";
import { SignedBalanceAmount } from "web_myplann/Finances/Components/SignedBalanceAmount";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";

type Props = {
	balance: number;
};

export const FinancialBalanceRemainderRow: FC<Props> = ({ balance }) => {
	const theme = useTheme();
	const { t } = useResource();

	return (
		<Stack
			direction="row"
			alignItems="center"
			justifyContent="space-between"
			pt={theme.spacingTokens.sm}
			borderTop={theme.colors.border.flatRowDivider}
		>
			<FinancialBalanceRowLabel
				icon={Wallet}
				iconColor={theme.palette.blue[500]}
				label={t(Resources.Dashboard.FinancialBalance.balance)}
			/>
			<SignedBalanceAmount balance={balance} size="sm" />
		</Stack>
	);
};
